<template lang="pug">
BriqDialog(
  @close="$emit('cancel')"
  dialogSize="briq-dialog-medium"
  )
  h2.h2.mb-S.text-center Hey, before you continue...
  .mb-S
    div Changing resource types can lead to loss of information and settings.
    div Do you still want to change the resource type?
  .buttons
    BriqButton.mr-15(variant="secondary" @click="$emit('cancel')" data-test-id="type-switch-warning-cancel") Cancel
    BriqSubmitButton(@click="changeResourceType" data-test-id="type-switch-warning-change-button") Change resource type
</template>

<script>
export default {
  name: 'TypeSwitchWarningModal',
  methods: {
    changeResourceType() {
      this.$emit('changeResourceType')
    },
  },
}
</script>

<style scoped lang="stylus">
.mr-15
  margin-right 15px

.buttons
  display flex
  justify-content center
</style>
